module.exports = __webpack_public_path__ + "img/icon-empty-content@2x.2fb4bd2f.png";